import { liveFaqSearch, initFaqSearchBar } from '../utilities/_faq-search';

const searchInput = document.querySelector('#s');
const searchForm = document.querySelector('#search-form');
const noFaqResult = document.querySelector('#noFaqResult');

if (document.querySelector('.accordion-section #search-form')) {
  document.addEventListener('DOMContentLoaded', accordionInit);
}

function accordionInit() {
  initFaqSearchBar({
    searchInput,
    searchForm,
    onSearch: () => liveFaqSearch({ searchInput, noFaqResult })
  });
}
